import * as types from "../../actions/types/index";
import {setInitialState} from "../../util/utility";

const INITIAL_STATE = setInitialState({
    payload: null,
});
export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.UPLOAD_BROADCAST_PROFILE_PICTURE_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.UPLOAD_BROADCAST_PROFILE_PICTURE_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                payload: action.payload.success
            };
        case types.UPLOAD_BROADCAST_PROFILE_PICTURE_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                payload: action.payload.response.error,
            };
        case types.RESET_UPLOAD_BROADCAST_PROFILE_PICTURE:
            return {
                ...state,
                payload: action.payload,
            };
        default:
            return {
                ...state
            }
    }
}